var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.position && _vm.text && _vm.shouldShow)?_c('GmapMarker',{attrs:{"position":_vm.position,"clickable":false,"icon":_vm.iconSpec,"z-index":6}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }